export type ExplosionRunWithCount = {
  result_count: number
}

export type ExplosionListKpis = {
  runs: number
  resultCountSum: number
}

export function computeExplosionListKpis(
  rows: ExplosionRunWithCount[],
): ExplosionListKpis {
  let resultCountSum = 0
  for (const r of rows) {
    resultCountSum += r.result_count ?? 0
  }
  return { runs: rows.length, resultCountSum }
}
